import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useBreadcrumbTitle } from '../utils/breadcrumbTitle.js';
import './Breadcrumbs.css';

const routeLabels = {
  '': 'Dashboard',
  contacts: 'Contacts',
  templates: 'Templates',
  campaigns: 'Campaigns',
  events: 'Events',
  registrations: 'Registrations',
  'rate-calculator': 'Rate Calculator',
  'signature-builder': 'Signature Builder',
  'video-backgrounds': 'Meeting Backgrounds',
  news: 'News',
  careers: 'Careers',
  'team-members': 'Team Members',
  ncfs: 'NCFs',
  admin: 'Admin'
};

const websiteRoutes = new Set(['news', 'careers', 'team-members']);
const marketingRoutes = new Set(['contacts', 'templates', 'campaigns']);
const eventsRoutes = new Set(['events', 'registrations']);

const getGroupCrumb = (firstSegment) => {
  if (websiteRoutes.has(firstSegment)) {
    return { label: 'Website' };
  }
  if (marketingRoutes.has(firstSegment)) {
    return { label: 'Marketing' };
  }
  if (eventsRoutes.has(firstSegment)) {
    return { label: 'Events' };
  }
  return null;
};

const getSegmentLabel = (segment, previousSegment) => {
  if (!segment) return 'Dashboard';
  if (previousSegment === 'campaigns') return 'Details';
  if (previousSegment === 'events') return 'Details';
  if (previousSegment === 'ncfs') return 'NCF';
  return routeLabels[segment] || decodeURIComponent(segment)
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

const Breadcrumbs = () => {
  const location = useLocation();
  const pageTitle = useBreadcrumbTitle();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  if (location.pathname === '/login' || location.pathname === '/auth/callback') {
    return null;
  }

  if (location.pathname.startsWith('/events/rsvp')) {
    return null;
  }

  const groupCrumb = getGroupCrumb(pathSegments[0]);

  const breadcrumbs = pathSegments.map((segment, index) => {
    const to = `/${pathSegments.slice(0, index + 1).join('/')}`;
    const previousSegment = index > 0 ? pathSegments[index - 1] : '';
    return {
      label: pageTitle.path === to && pageTitle.title ? pageTitle.title : getSegmentLabel(segment, previousSegment),
      to
    };
  });

  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      <ol>
        <li>
          <Link to="/">Dashboard</Link>
        </li>
        {groupCrumb && (
          <li>
            {groupCrumb.label === 'Marketing' ? (
              <Link to="/marketing-dashboard">Marketing</Link>
            ) : groupCrumb.label === 'Events' ? (
              <Link to="/events">Events</Link>
            ) : (
              <span aria-current={breadcrumbs.length === 0 ? 'page' : undefined}>{groupCrumb.label}</span>
            )}
          </li>
        )}
        {breadcrumbs.map((crumb, index) => {
          const isLast = index === breadcrumbs.length - 1;
          return (
            <li key={crumb.to}>
              {isLast ? (
                <span aria-current="page">{crumb.label}</span>
              ) : (
                <Link to={crumb.to}>{crumb.label}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
